// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__3OH_y","figure":"styles_figure__2IHj5","animate":"styles_animate__3chWg","rotate":"styles_rotate__V9D2P"};